import {Injectable} from '@angular/core';
import {LoanApplicationFlowStep} from './loan-application-flow.step';

@Injectable()
export class IntroStep extends LoanApplicationFlowStep {
    async isComplete(): Promise<boolean> {
        return true;
    }

    url(): string {
        return this.createBorrowerFlowUrl('intro');
    }

    description(): string {
        return undefined;
    }

    displayName(): string {
        return undefined;
    }

    showWelcomePageOnLeftPane() {
        return true;
    }
}